import React from 'react';
import { Mail, Instagram } from 'lucide-react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTelegram } from "@fortawesome/free-brands-svg-icons";
import { useLocalization } from '../../utils/hooks/useLocalization'
import { parseStringTags } from '../../utils/textUtils';
import styles from './DiscoverPage.module.css';
import social from "../../data/social"

const DiscoverPage = () => {
  const { t } = useLocalization();
  return (
    <>
      <section className={styles.discover}>
        <div className={styles.backgroundText}>VIBE</div>
        
        <div className={styles.container}>
            <h2 className={styles.title}>
              <span className={styles.titleAccent}>DISCOVER</span>
              <span className={styles.titleMain}>NOW</span>
            </h2>

            
        <p className={styles.description}>
          {parseStringTags(t("discover_description"))}
        </p>

        <p className={styles.description}>
          {parseStringTags(t("discover_call2action"))}
        </p>
          

        <div className={styles.grid}>
          <a className={styles.card} href="mailto:info@dtune.it">
            <Mail className={styles.icon} size={48} />
              <h3 className={styles.cardTitle}>info@dtune.it</h3>
          </a>
          
          <a className={styles.card} href={`https://t.me/${social.telegram}`} target="_blank" rel="noopener noreferrer">
             <FontAwesomeIcon className={styles.icon2} icon={faTelegram} style={{ fontSize: "48px", paddingBottom: "6px" }} />
              <h3 className={styles.cardTitle}>@{social.telegram}</h3>
          </a>
          
          <a className={styles.card} href={`https://www.instagram.com/${social.instagram}`} target="_blank" rel="noopener noreferrer">
              <Instagram className={styles.icon3} size={48} />
              <h3 className={styles.cardTitle}>@{social.instagram}</h3>
          </a>
          
        </div>
            
          
        </div>
      </section>
    </>
  );
};

export default DiscoverPage;

